module.exports = __webpack_public_path__ + "img/logo.704d9461.png";